import React from 'react';
import { 
  User,
  AlertTriangle,
  Home,
  Wallet,
  HeartPulse,
  Stethoscope,
  Activity,
  Briefcase,
  Users,
  UserX,
  ClipboardCopy,
  Printer
} from 'lucide-react';
// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const StudentInfoReportUI = ({ data, meta }) => {
  const ans = meta?.answers || data?.answers || {};
  const risks = data?.risks || [];

  // Boş alanlar için tire çekelim
  const val = (id) => ans[id] && ans[id].trim() !== "" ? ans[id] : "-";

  return (
    <div className="space-y-4 print:space-y-3 font-sans flex flex-col print:min-h-[260mm] print:text-black">
      {/* ÜST BAŞLIK */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 print:h-10 print:w-10 rounded-xl flex items-center justify-center bg-blue-600 print:bg-slate-100 print:border print:border-slate-300">
            <User className="h-6 w-6 print:h-5 print:w-5 text-white print:text-slate-700"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-black leading-none mb-1 uppercase">
  {meta?.studentName || (val(1) !== "-" ? val(1) : "İsimsiz Öğrenci")}
</h2>

<span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
   {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || (val(302) !== "-" ? val(302) : "-")}
</span>
          </div>
        </div>
        <div className="text-right print:text-left">
            <span className="text-[10px] font-bold text-slate-400 block uppercase tracking-widest">Kayıt Tarihi</span>
            <span className="text-sm font-black">{new Date(meta?.timestamp || meta?.date || Date.now()).toLocaleDateString('tr-TR')}</span>
        </div>
      </div>

      <div className="bg-blue-50 text-blue-800 p-3 rounded-lg text-xs font-bold border border-blue-100 print:border-slate-300 print:bg-slate-50 print:text-slate-700 text-center uppercase tracking-widest avoid-break">
        GİZLİDİR - PDR Servisi Öğrenci Tanıma Dosyası
      </div>

      {/* 1. KİŞİSEL BİLGİLER & ADRES */}
      <div className="border border-slate-200 print:border-slate-300 rounded-xl overflow-hidden avoid-break">
         <div className="bg-slate-100 print:bg-slate-200 px-4 py-2 border-b border-slate-200 print:border-slate-300 font-bold text-xs uppercase tracking-wider text-slate-700">1. Kişisel Bilgiler ve Ulaşım</div>
         <div className="grid grid-cols-2 md:grid-cols-4 print:grid-cols-4 divide-y md:divide-y-0 md:divide-x print:divide-y-0 print:divide-x divide-slate-100 print:divide-slate-200 bg-white">
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Doğum Yeri</span><span className="text-xs font-semibold text-slate-800">{val(2)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Doğum Tarihi</span><span className="text-xs font-semibold text-slate-800">{val(201)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Ev Adresi</span><span className="text-xs font-semibold text-slate-800">{val(4)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Okula Ulaşım</span><span className="text-xs font-semibold text-slate-800">{val(19)}</span></div>
         </div>
      </div>

      {/* 2. AİLE YAPISI */}
      <div className="border border-slate-200 print:border-slate-300 rounded-xl overflow-hidden avoid-break">
         <div className="bg-slate-100 print:bg-slate-200 px-4 py-2 border-b border-slate-200 print:border-slate-300 font-bold text-xs uppercase tracking-wider text-slate-700">2. Aile Dinamikleri</div>
         <div className="grid grid-cols-2 md:grid-cols-4 print:grid-cols-4 divide-y md:divide-y-0 md:divide-x print:divide-y-0 print:divide-x divide-slate-100 print:divide-slate-200 bg-white">
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Kiminle Yaşıyor?</span><span className="text-xs font-semibold text-slate-800">{val(5)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Anne/Baba Hayatta Mı?</span><span className="text-xs font-semibold text-slate-800">{val(6)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Birliktelik Durumu</span><span className="text-xs font-semibold text-slate-800">{val(7)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Kardeş Sayısı</span><span className="text-xs font-semibold text-slate-800">{val(8)}</span></div>
         </div>
      </div>

      {/* 3. VELİ VE EĞİTİM DURUMU */}
      <div className="border border-slate-200 print:border-slate-300 rounded-xl overflow-hidden avoid-break">
         <div className="bg-slate-100 print:bg-slate-200 px-4 py-2 border-b border-slate-200 print:border-slate-300 font-bold text-xs uppercase tracking-wider text-slate-700">3. Veli ve Ebeveyn Eğitimi</div>
         <div className="grid grid-cols-2 md:grid-cols-4 print:grid-cols-4 divide-y md:divide-y-0 md:divide-x print:divide-y-0 print:divide-x divide-slate-100 print:divide-slate-200 bg-white">
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Resmi Veli Kim?</span><span className="text-xs font-semibold text-slate-800">{val(140)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Veli Adı & Tel</span><span className="text-xs font-semibold text-slate-800">{val(14)} <br/> {val(15)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Anne Eğitim</span><span className="text-xs font-semibold text-slate-800">{val(13)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Baba Eğitim</span><span className="text-xs font-semibold text-slate-800">{val(12)}</span></div>
         </div>
      </div>

      {/* 4. SOSYO-EKONOMİK DURUM */}
      <div className="border border-slate-200 print:border-slate-300 rounded-xl overflow-hidden avoid-break">
         <div className="bg-slate-100 print:bg-slate-200 px-4 py-2 border-b border-slate-200 print:border-slate-300 font-bold text-xs uppercase tracking-wider text-slate-700">4. Sosyo-Ekonomik Durum</div>
         <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 divide-y md:divide-y-0 md:divide-x print:divide-y-0 print:divide-x divide-slate-100 print:divide-slate-200 bg-white">
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Aylık Ortalama Gelir</span><span className="text-xs font-semibold text-slate-800">{val(9)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Ev Durumu</span><span className="text-xs font-semibold text-slate-800">{val(10)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Öğrenci Çalışıyor Mu?</span><span className="text-xs font-semibold text-slate-800">{val(11)}</span></div>
         </div>
      </div>

      {/* 5. SAĞLIK VE ÖZEL DURUM */}
      <div className="border border-slate-200 print:border-slate-300 rounded-xl overflow-hidden avoid-break">
         <div className="bg-slate-100 print:bg-slate-200 px-4 py-2 border-b border-slate-200 print:border-slate-300 font-bold text-xs uppercase tracking-wider text-slate-700">5. Sağlık ve Özel Durumlar</div>
         <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 divide-y md:divide-y-0 md:divide-x print:divide-y-0 print:divide-x divide-slate-100 print:divide-slate-200 bg-white">
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Sürekli Hastalık</span><span className="text-xs font-semibold text-slate-800">{val(16)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Sürekli İlaç</span><span className="text-xs font-semibold text-slate-800">{val(17)}</span></div>
            <div className="p-3"><span className="block text-[9px] font-bold text-slate-400 uppercase tracking-wider">Kaza / Ameliyat</span><span className="text-xs font-semibold text-slate-800">{val(18)}</span></div>
         </div>
      </div>

      {/* 6. OTOMATİK RİSK ETİKETLERİ */}
      <div className="mt-2 p-4 print:p-3 bg-white border border-slate-200 print:border-slate-300 rounded-xl avoid-break flex-1">
         <h3 className="font-bold text-slate-800 text-xs mb-3 flex items-center uppercase tracking-wide border-b pb-2 print:border-slate-200"><AlertTriangle className="h-4 w-4 mr-2 text-amber-500"/> Sistem Tarafından Tespit Edilen Durumlar</h3>
         <div className="flex flex-wrap gap-2 print:gap-1.5">
            {risks.length > 0 ? risks.map((r, idx) => (
              <div key={idx} className={`px-2.5 py-1.5 print:px-2 print:py-1 rounded-lg text-[10px] print:text-[9px] font-bold border flex items-center gap-1.5 ${r.isCritical ? 'bg-red-50 border-red-100 text-red-700 print:border-slate-300 print:bg-white print:text-black' : 'bg-slate-100 border-slate-200 text-slate-700 print:border-slate-300 print:bg-white print:text-black'}`}>
                <div className={`w-1.5 h-1.5 rounded-full ${r.isCritical ? 'bg-red-500 print:bg-black' : 'bg-slate-400 print:bg-slate-400'}`} />
                {r.text} {r.detail && <span className="font-normal opacity-80">({r.detail})</span>}
              </div>
            )) : (
              <span className="text-xs text-slate-400 italic">Öğrencinin formunda belirgin bir risk tespit edilmemiştir.</span>
            )}
         </div>
      </div>
    </div>
  );
};


// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateStudentInfo = (subs) => {

  // Aynı öğrencinin formu birden fazla kez doldurulmuşsa
  // kurumsal istatistiklerde yalnızca en güncel kaydı kullan.
  const getRecordTime = (sub) => {
    const value = sub.timestamp ?? sub.createdAt ?? sub.date ?? sub.id;

    if (value?.toMillis) return value.toMillis();
    if (value?.seconds) return value.seconds * 1000;
    if (typeof value === 'number') return value;

    const parsed = Date.parse(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const latestByStudent = new Map();

    subs.forEach((sub, index) => {

    const studentNo =
      String(
        sub.studentNo ??
        sub.answers?.[302] ??
        ''
      ).trim();

    // ============================================================
// ÖĞRENCİ KİMLİĞİ
// ============================================================
//
// Sınıf öğrencinin kimliğinin parçası değildir.
//
// Öğrenci sınıf değiştirse bile:
//   B1 / 125
//   D  / 125
//
// aynı öğrencidir.
//
// Bu nedenle kurumsal istatistiklerde tekilleştirme
// yalnız okul numarası üzerinden yapılır.
//
// sub.studentClass ise tarihsel bilgi olarak kayıtta kalır.
// ============================================================

const studentKey =
  studentNo &&
  studentNo !== '0'

    ? studentNo

    : `__record_${index}`;

    const existing =
      latestByStudent.get(studentKey);

    if (
      !existing ||
      getRecordTime(sub) >=
        getRecordTime(existing)
    ) {
      latestByStudent.set(
        studentKey,
        sub
      );
    }
  });

  const uniqueSubs = Array.from(latestByStudent.values());

  const stats = {
    total: uniqueSubs.length,
    anneVefat: 0, babaVefat: 0, ikisiVefat: 0, toplamVefat: 0,
    parcalanmisAile: 0, ebeveynDisiBakim: 0,
    dusukGelir: 0, kiradaOturan: 0, calisanOgrenci: 0, cokKardesli: 0,
    kronikHasta: 0, surekliIlac: 0,
    // 🚀 YENİ: İsimleri biriktireceğimiz kategorize listeler
    listeler: {
      vefat: [],
      parcalanmis: [],
      ebeveynDisi: [],
      ekonomikRisk: [],
      calisan: [],
      saglik: [],
      surekliIlac: []
    }
  };

  if (stats.total === 0) return stats;

  uniqueSubs.forEach(sub => {
    const r = sub.reportData?.raw;
    if (!r) return; 

    // Öğrenci Künyesi (Örn: Burak Kaya - 10/A - 123)
    const subClass = sub.studentClass && sub.studentClass !== "Sınıfsız" ? sub.studentClass : "";
    const subNo = sub.studentNo && sub.studentNo !== "0" ? sub.studentNo : "";
    const classNoInfo = [subClass, subNo].filter(Boolean).join(" / ");
    const stInfo = `${sub.studentName || "İsimsiz"} ${classNoInfo ? `(${classNoInfo})` : ""}`;

    // Ailevi Durumlar
    let isVefat = false;
    let vefatTuru = "";
    if (r.anneBabaHayatta === 'Anne Vefat') { stats.anneVefat++; isVefat = true; vefatTuru = "Anne Vefat"; }
    if (r.anneBabaHayatta === 'Baba Vefat') { stats.babaVefat++; isVefat = true; vefatTuru = "Baba Vefat"; }
    if (r.anneBabaHayatta === 'Ikisi Vefat') { stats.ikisiVefat++; isVefat = true; vefatTuru = "İkisi Vefat"; }
    if (isVefat) stats.listeler.vefat.push(`${stInfo} [${vefatTuru}]`);
    
    if (r.birliktelik === 'Ayri') { 
        stats.parcalanmisAile++; 
        stats.listeler.parcalanmis.push(stInfo); 
    }
    
    if (r.kiminleYasiyor === 'Akraba' || r.kiminleYasiyor === 'Diğer') { 
        stats.ebeveynDisiBakim++; 
        stats.listeler.ebeveynDisi.push(`${stInfo} [${r.kiminleYasiyor}]`); 
    }
    
    if (r.kardesSayisi === '5+') stats.cokKardesli++;

    // Ekonomik Durumlar
    if (r.gelirDurumu === 'Yok' || r.gelirDurumu === 'Dusuk') { 
        stats.dusukGelir++; 
        stats.listeler.ekonomikRisk.push(`${stInfo} [${r.gelirDurumu === 'Yok' ? 'Gelir Yok' : 'Düşük Gelir'}]`); 
    }
    
    if (r.evDurumu === 'Kira') stats.kiradaOturan++;
    
    if (r.calisiyorMu === 'Evet') { 
        stats.calisanOgrenci++; 
        stats.listeler.calisan.push(stInfo); 
    }

    // Sağlık Durumları
    if (r.kronikHastalik) { 
        stats.kronikHasta++; 
        const detail = sub.answers?.[16] ? ` [${sub.answers[16]}]` : '';
        stats.listeler.saglik.push(stInfo + detail); 
    }
    
    if (r.ilacKullanimi) { 
        stats.surekliIlac++; 
        const detail = sub.answers?.[17] ? ` [${sub.answers[17]}]` : '';
        stats.listeler.surekliIlac.push(stInfo + detail); 
    }
  });

  stats.toplamVefat = stats.anneVefat + stats.babaVefat + stats.ikisiVefat;

  return stats;
};



// ============================================================
// ÖĞRENCİ BİLGİ FORMU — KATILIM TAKİP MOTORU
// ============================================================

// Ad / sınıf / şube / okul no gibi sistem tarafından
// otomatik gelebilecek kimlik alanlarını özellikle dahil etmiyoruz.
//
// Amaç:
// Öğrencinin formun GERÇEK içeriğine en az bir cevap
// verip vermediğini anlamak.
const STUDENT_INFO_CONTENT_FIELD_IDS = [
  2,
  201,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  140,
  14,
  15,
  160,
  16,
  170,
  17,
  180,
  18,
  19
];


const normalizeStudentInfoClass = value =>
  String(value || '')
    .trim()
    .toUpperCase();


const normalizeStudentInfoNo = value =>
  String(value ?? '')
    .trim();


const hasStudentInfoAnswerValue = value => {

  if (
    value === null ||
    value === undefined
  ) {
    return false;
  }


  if (typeof value === 'string') {
    return value.trim() !== '';
  }


  if (Array.isArray(value)) {
    return value.some(
      hasStudentInfoAnswerValue
    );
  }


  if (typeof value === 'object') {
    return Object.values(value).some(
      hasStudentInfoAnswerValue
    );
  }


  return true;
};


const hasMeaningfulStudentInfoAnswers = answers => {

  if (
    !answers ||
    typeof answers !== 'object'
  ) {
    return false;
  }


  return STUDENT_INFO_CONTENT_FIELD_IDS.some(
    fieldId =>
      hasStudentInfoAnswerValue(
        answers[fieldId]
      )
  );
};


// ------------------------------------------------------------
// SINIF LİSTESİ + FORM KAYITLARINI KARŞILAŞTIR
// ------------------------------------------------------------
export const buildStudentInfoParticipation = ({
  submissions = [],
  allClasses = [],
  filterClass = null
}) => {

  const wantedClass =
    filterClass
      ? normalizeStudentInfoClass(
          filterClass
        )
      : null;


  const rosterClasses =
    (Array.isArray(allClasses)
      ? allClasses
      : []
    )
      .filter(classItem => {

        if (!wantedClass) {
          return true;
        }

        return (
          normalizeStudentInfoClass(
            classItem?.name
          ) ===
          wantedClass
        );
      });


  // ----------------------------------------------------------
// FORM KAYITLARINI ÖĞRENCİ NUMARASINA GÖRE GRUPLA
// ----------------------------------------------------------
//
// Öğrencinin güncel sınıfı allClasses listesinden gelir.
//
// Submission içindeki studentClass:
//   öğrencinin formu doldurduğu tarihteki sınıftır.
//
// Bu nedenle form katılımı belirlenirken sınıf,
// öğrenci kimliğinin parçası olarak kullanılmaz.
// ----------------------------------------------------------

const recordsByStudent =
  new Map();


submissions.forEach(sub => {

  const studentNo =
    normalizeStudentInfoNo(
      sub?.studentNo ??
      sub?.answers?.[302]
    );


  if (!studentNo) {
    return;
  }


  const key =
    studentNo;


  if (!recordsByStudent.has(key)) {
    recordsByStudent.set(
      key,
      []
    );
  }


  recordsByStudent
    .get(key)
    .push(sub);
});


  const classResults =
    rosterClasses.map(classItem => {

      const className =
        String(
          classItem?.name ||
          ''
        ).trim();


    


      const students =
        Array.isArray(
          classItem?.students
        )
          ? classItem.students
          : [];


      const result = {
        className,

        total:
          students.length,

        completed: [],

        blank: [],

        missing: []
      };


      students.forEach(student => {

        const studentNo =
          normalizeStudentInfoNo(
            student?.no
          );


        const studentName =
          String(
            student?.name ||
            ''
          ).trim();


       const key =
  studentNo;


const records =
  recordsByStudent.get(key) ||
  [];


        const studentInfo = {
          no: studentNo,
          name:
            studentName ||
            'İsimsiz Öğrenci',
          className
        };


        // Hiç kayıt yok.
        if (records.length === 0) {

          result.missing.push(
            studentInfo
          );

          return;
        }


        // Birden fazla submission varsa:
        // Bunlardan EN AZ BİRİ anlamlı biçimde doldurulmuşsa
        // öğrenciyi tamamladı kabul ediyoruz.
        //
        // Böylece daha sonra yanlışlıkla gönderilmiş boş
        // ikinci bir kayıt öğrenciyi "boş" durumuna düşürmez.
        const hasMeaningfulRecord =
          records.some(record =>
            hasMeaningfulStudentInfoAnswers(
              record?.answers
            )
          );


        if (hasMeaningfulRecord) {

          result.completed.push(
            studentInfo
          );

        } else {

          result.blank.push(
            studentInfo
          );
        }

      });


      return result;
    });


  const summary =
    classResults.reduce(
      (acc, classItem) => {

        acc.total +=
          classItem.total;

        acc.completed +=
          classItem.completed.length;

        acc.blank +=
          classItem.blank.length;

        acc.missing +=
          classItem.missing.length;

        return acc;

      },
      {
        total: 0,
        completed: 0,
        blank: 0,
        missing: 0
      }
    );


  return {
    summary,
    classes:
      classResults
  };
};

// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const StudentInfoKurumsalUI = ({
  title,
  subs,
  handlePrint,
  downloading,
  registeredTotal = null,

  // Katılım takibi için:
  participationSubs = [],
  allClasses = [],
  filterClass = null
}) => {
  const data = aggregateStudentInfo(subs);

  const [activeReportTab, setActiveReportTab] =
  React.useState('summary');

  const participation =
  buildStudentInfoParticipation({
    submissions:
      participationSubs,
    allClasses,
    filterClass
  });


const participationSummary =
  participation.summary;


const hasParticipationRoster =
  participationSummary.total > 0;


const incompleteStudentCount =
  participationSummary.blank +
  participationSummary.missing;
  
  const hasProcessedData =
  Boolean(
    data &&
    data.total > 0
  );


if (
  !hasProcessedData &&
  !hasParticipationRoster
) {
  return (
    <div className="p-8 text-center text-slate-500 font-bold">
      Bu gruba ait öğrenci listesi veya form verisi bulunamadı.
    </div>
  );
}


const getPercent = val =>
  hasProcessedData
    ? Math.round(
        (val / data.total) * 100
      )
    : 0;


const hasRegisteredTotal =
  Number.isFinite(
    Number(registeredTotal)
  ) &&
  Number(registeredTotal) > 0;


// Katılım motorunda gerçek sınıf listesi varsa
// öncelikle onu esas al.
const totalStudents =
  hasParticipationRoster
    ? participationSummary.total
    : hasRegisteredTotal
      ? Number(registeredTotal)
      : null;


// "Tamamlayan" artık yalnızca gerçekten
// içerik yanıtı bulunan öğrencidir.
const completedCount =
  hasParticipationRoster
    ? participationSummary.completed
    : data?.total || 0;


const pendingCount =
  totalStudents !== null
    ? hasParticipationRoster
      ? incompleteStudentCount
      : Math.max(
          0,
          totalStudents -
          (data?.total || 0)
        )
    : null;


const participationRate =
  totalStudents &&
  totalStudents > 0

    ? Math.min(
        100,
        Math.round(
          (
            completedCount /
            totalStudents
          ) * 100
        )
      )

    : null;


// ============================================================
// KATILIM TAKİBİ — GÖRÜNÜR LİSTE HAZIRLIĞI
// ============================================================

const participationClassesForDisplay =
  [...(participation.classes || [])]
    .sort(
      (a, b) =>
        String(
          a?.className || ''
        ).localeCompare(
          String(
            b?.className || ''
          ),
          'tr',
          {
            numeric: true
          }
        )
    )
    .map(classItem => {

      const issues = [

        ...(classItem.missing || [])
          .map(student => ({
            ...student,

            status:
              'Hiç Doldurmadı',

            statusType:
              'missing'
          })),

        ...(classItem.blank || [])
          .map(student => ({
            ...student,

            status:
              'Boş Gönderdi',

            statusType:
              'blank'
          }))

      ].sort(
        (a, b) =>
          String(
            a?.no || ''
          ).localeCompare(
            String(
              b?.no || ''
            ),
            'tr',
            {
              numeric: true
            }
          )
      );


      return {
        ...classItem,
        issues
      };
    });


// ============================================================
// KATILIM TAKİBİ — EKSİK / TAMAMLANAN SINIF AYRIMI
// ============================================================

const incompleteClassesForDisplay =
  participationClassesForDisplay.filter(
    classItem =>
      classItem.issues.length > 0
  );


const completedClassNames =
  participationClassesForDisplay
    .filter(
      classItem =>
        classItem.issues.length === 0
    )
    .map(
      classItem =>
        classItem.className
    );

const buildIncompleteStudentText = () => {

  const lines = [
    'ÖĞRENCİ BİLGİ FORMU – EKSİK ÖĞRENCİLER',
    ''
  ];


  participationClassesForDisplay
    .filter(
      classItem =>
        classItem.issues.length > 0
    )
    .forEach(classItem => {

      lines.push(
        `${classItem.className} (${classItem.issues.length} öğrenci)`
      );


      classItem.issues.forEach(
        student => {

          lines.push(
            `${student.no} - ${student.name} — ${student.status}`
          );

        }
      );


      lines.push('');
    });


  return lines
    .join('\n')
    .trim();
};


const copyIncompleteStudentList =
  async () => {

    const text =
      buildIncompleteStudentText();


    if (!text) {
      alert(
        'Eksik öğrenci bulunmuyor.'
      );

      return;
    }


    try {

      if (
        navigator?.clipboard
          ?.writeText
      ) {

        await navigator.clipboard
          .writeText(text);

      } else {

        const textarea =
          document.createElement(
            'textarea'
          );


        textarea.value =
          text;

        textarea.style.position =
          'fixed';

        textarea.style.opacity =
          '0';


        document.body
          .appendChild(
            textarea
          );


        textarea.select();


        document.execCommand(
          'copy'
        );


        document.body
          .removeChild(
            textarea
          );
      }


      alert(
        '✅ Eksik öğrenci listesi panoya kopyalandı.'
      );

    } catch (error) {

      console.error(
        'Liste kopyalanamadı:',
        error
      );


      alert(
        'Liste kopyalanırken bir hata oluştu.'
      );
    }
  };


  return (


    <div className="space-y-6">

  {/* ===================================================== */}
  {/* BİLGİ ÖZETİ / KATILIM TAKİBİ SEKMELERİ */}
  {/* ===================================================== */}

  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 no-print px-2">

    <div className="inline-flex items-center bg-slate-100 border border-slate-200 rounded-2xl p-1.5 w-fit">

      <button
        type="button"
        onClick={() =>
          setActiveReportTab('summary')
        }
        className={`px-5 py-2.5 rounded-xl text-sm font-black transition ${
          activeReportTab === 'summary'
            ? 'bg-white text-slate-900 shadow-sm border border-slate-200'
            : 'text-slate-500 hover:text-slate-800'
        }`}
      >
        Bilgi Özeti
      </button>


      <button
        type="button"
        onClick={() =>
          setActiveReportTab('participation')
        }
        disabled={!hasParticipationRoster}
        className={`px-5 py-2.5 rounded-xl text-sm font-black transition ${
          activeReportTab === 'participation'
            ? 'bg-indigo-600 text-white shadow-sm'
            : 'text-slate-500 hover:text-indigo-700'
        } disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        Katılım Takibi

        {hasParticipationRoster && incompleteStudentCount > 0 && (
          <span className={`ml-2 px-2 py-0.5 rounded-full text-[10px] ${
            activeReportTab === 'participation'
              ? 'bg-white/20 text-white'
              : 'bg-rose-100 text-rose-700'
          }`}>
            {incompleteStudentCount}
          </span>
        )}
      </button>

    </div>


    {/* AKTİF SEKMEYE ÖZEL İŞLEMLER */}
    <div className="flex flex-wrap gap-2">

      {activeReportTab === 'summary' && (

        <button
          type="button"
          onClick={() =>
            handlePrint(
              'studentinfo-kurumsal-area'
            )
          }
          disabled={downloading}
          className="bg-slate-800 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-slate-900 transition"
        >
          <Printer className="h-4 w-4 mr-2" />

          {
            downloading
              ? 'PDF Hazırlanıyor...'
              : 'Bilgi Özetini Yazdır / PDF'
          }
        </button>

      )}


      {activeReportTab === 'participation' && (

        <>

          <button
            type="button"
            onClick={
              copyIncompleteStudentList
            }
            disabled={
              incompleteStudentCount === 0
            }
            className="bg-white border border-slate-300 text-slate-700 px-4 py-2.5 rounded-xl font-bold flex items-center text-sm hover:bg-slate-50 transition disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <ClipboardCopy className="h-4 w-4 mr-2" />

            Eksik Listeyi Kopyala
          </button>


          <button
            type="button"
            onClick={() =>
              handlePrint(
                'studentinfo-participation-area'
              )
            }
            disabled={downloading}
            className="bg-indigo-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-indigo-700 transition"
          >
            <Printer className="h-4 w-4 mr-2" />

            {
              downloading
                ? 'PDF Hazırlanıyor...'
                : 'Katılım Takibini Yazdır / PDF'
            }
          </button>

        </>

      )}

    </div>

  </div>

      <div id="studentinfo-kurumsal-area" className="font-sans flex flex-col bg-slate-50 print:bg-white p-6 print:p-0 rounded-3xl">
        
        {/* ÜST BAŞLIK: TOPLAM SAYILAR */}
       <div
  className={`bg-slate-800 text-white p-8 print:p-4 rounded-3xl mb-6 flex justify-between items-center shadow-lg print:bg-transparent print:text-black print:border-b-2 print:border-slate-300 print:shadow-none print:rounded-none ${
    activeReportTab === 'summary'
      ? ''
      : 'hidden'
  }`}
>
          <div>
            <h2 className="text-3xl print:text-2xl font-black tracking-tight print:text-slate-800">{title}</h2>
            <span className="text-indigo-300 print:text-slate-500 font-bold tracking-widest text-xs uppercase mt-1 block">Sayısal Demografi ve Risk Haritası</span>
          </div>
          <div className="text-right border-l border-slate-600 pl-6 print:border-slate-300">
   <span className="text-5xl print:text-4xl font-black block text-blue-400 print:text-slate-800">
  {data.total}
</span>

<span className="text-[10px] uppercase tracking-widest font-bold text-slate-400 print:text-slate-500">
  İşlenmiş Form
</span>
</div>
        </div>



<div
  className={`mb-6 px-4 py-3 bg-blue-50 border border-blue-100 rounded-xl text-xs font-semibold text-blue-800 ${
    activeReportTab === 'summary'
      ? ''
      : 'hidden'
  }`}
>
  Aşağıdaki risk ve demografi göstergeleri sistemde işlenmiş {data.total} form kaydı üzerinden hesaplanmıştır.
</div>

{/* ======================================================= */}
{/* ÖĞRENCİ BİLGİ FORMU — KATILIM TAKİBİ */}
{/* ======================================================= */}

{hasParticipationRoster && (

  <div
  id="studentinfo-participation-area"
  className={`bg-white border border-slate-200 rounded-3xl overflow-hidden shadow-sm ${
    activeReportTab === 'participation'
      ? ''
      : 'hidden'
  }`}
>

    {/* BAŞLIK */}
    <div className="participation-report-header px-6 py-5 bg-slate-900 text-white flex flex-col md:flex-row md:items-center md:justify-between gap-4 print:bg-white print:text-black print:border-b-2 print:border-slate-900">

      <div className="flex items-center">

        <div className="h-11 w-11 rounded-xl bg-indigo-500/20 flex items-center justify-center mr-3 print:bg-slate-100">

          <Users className="h-5 w-5 text-indigo-300 print:text-slate-700" />

        </div>


        <div>

          <h3 className="font-black text-lg">
            Öğrenci Bilgi Formu Katılım Takibi
          </h3>

          <p className="text-[11px] text-slate-400 print:text-slate-500 font-semibold mt-1">
            {
              filterClass
                ? `${filterClass} sınıfı`
                : 'Okul geneli'
            }
            {' • '}
            Eksik ve boş gönderilen formların sınıf bazlı takibi
          </p>

        </div>

      </div>


     
    </div>


    <div className="participation-report-content p-6">

      {/* 4 ÖZET KART */}
      <div className="participation-summary-grid grid grid-cols-2 md:grid-cols-4 print:grid-cols-4 gap-3 mb-6">

        <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 text-center">

          <span className="block text-2xl font-black text-slate-800">
            {participationSummary.total}
          </span>

          <span className="text-[10px] font-black uppercase tracking-wider text-slate-400">
            Kayıtlı Öğrenci
          </span>

        </div>


        <div className="rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-center">

          <span className="block text-2xl font-black text-emerald-700">
            {participationSummary.completed}
          </span>

          <span className="text-[10px] font-black uppercase tracking-wider text-emerald-600">
            Doldurdu
          </span>

        </div>


        <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 text-center">

          <span className="block text-2xl font-black text-amber-700">
            {participationSummary.blank}
          </span>

          <span className="text-[10px] font-black uppercase tracking-wider text-amber-600">
            Boş Gönderdi
          </span>

        </div>


        <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-center">

          <span className="block text-2xl font-black text-rose-700">
            {participationSummary.missing}
          </span>

          <span className="text-[10px] font-black uppercase tracking-wider text-rose-600">
            Hiç Doldurmadı
          </span>

        </div>

      </div>


      {/* KATILIM ORANI */}
      <div className="participation-rate-box mb-6 rounded-xl bg-indigo-50 border border-indigo-100 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">

        <div>

          <p className="text-xs font-black text-indigo-900">
            Gerçek Form Katılımı
          </p>

          <p className="text-[10px] font-semibold text-indigo-700 mt-1">
            Boş gönderilen formlar tamamlanmış kabul edilmez.
          </p>

        </div>


        <span className="text-2xl font-black text-indigo-700">

          %
          {
            participationSummary.total > 0
              ? Math.round(
                  (
                    participationSummary.completed /
                    participationSummary.total
                  ) * 100
                )
              : 0
          }

        </span>

      </div>


      {/* ======================================================= */}
{/* SINIF SINIF KOMPAKT KATILIM TABLOSU */}
{/* ======================================================= */}

<div className="participation-class-grid grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 items-start">

  {incompleteClassesForDisplay.map(
    classItem => {

      const issueCount =
        classItem.issues.length;


      const missingStudents =
        classItem.issues.filter(
          student =>
            student.statusType ===
            'missing'
        );


      const blankStudents =
        classItem.issues.filter(
          student =>
            student.statusType ===
            'blank'
        );


      // Çok eksikli sınıflar iki sütun genişliğinde gösterilir.
      // Öğrenci listesi de kendi içinde iki kolona bölünür.
      const isWideClass =
        issueCount >= 12;


      return (

        <div
          key={classItem.className}
          className={`participation-class-card border border-slate-200 rounded-2xl overflow-hidden bg-white h-fit ${
            isWideClass
              ? 'participation-class-card-wide md:col-span-2 xl:col-span-2'
              : ''
          }`}
        >

          {/* SINIF BAŞLIĞI */}
          <div className="participation-class-head px-3 py-2.5 bg-slate-50 border-b border-slate-200 flex items-start justify-between gap-2">

            <div>

              <h4 className="text-sm font-black text-slate-800">
                {classItem.className}
              </h4>

              <p className="participation-class-meta text-[10px] font-semibold text-slate-400 mt-0.5">

                {classItem.total} öğrenci

                {' • '}

                {classItem.completed.length} doldurdu

              </p>

            </div>


            <span className="participation-class-badge px-2.5 py-1 rounded-full bg-rose-100 text-rose-700 text-[10px] font-black whitespace-nowrap">

              {issueCount} eksik

            </span>

          </div>


          <div className="p-2.5 space-y-2">

            {/* HİÇ DOLDURMAYANLAR */}
            {missingStudents.length > 0 && (

              <div>

                <div className="flex items-center justify-between px-1 pb-1.5">

                  <span className="text-[9px] font-black uppercase tracking-wide text-rose-600">
                    Doldurmadı
                  </span>

                  <span className="text-[9px] font-black text-rose-600">
                    {missingStudents.length}
                  </span>

                </div>


                <div
                  className={`participation-student-list ${
                    isWideClass
                      ? 'grid grid-cols-1 sm:grid-cols-2 gap-x-3'
                      : 'space-y-1'
                  }`}
                >

                  {missingStudents.map(
                    student => (

                      <div
                        key={
                          `${classItem.className}-${student.no}-missing`
                        }
                        className="participation-student-row flex items-center gap-2 py-1.5 border-b border-slate-100 last:border-0"
                      >

                        <span className="student-no w-12 shrink-0 text-[10px] font-black text-slate-500">
                          {student.no}
                        </span>


                        <span className="student-name min-w-0 flex-1 text-[10px] font-bold text-slate-800 leading-tight">
                          {student.name}
                        </span>

                      </div>

                    )
                  )}

                </div>

              </div>

            )}


            {/* BOŞ GÖNDERENLER */}
            {blankStudents.length > 0 && (

              <div className="pt-1 border-t border-amber-100">

                <div className="flex items-center justify-between px-1 pb-1.5">

                  <span className="text-[9px] font-black uppercase tracking-wide text-amber-700">
                    Boş Gönderdi
                  </span>

                  <span className="text-[9px] font-black text-amber-700">
                    {blankStudents.length}
                  </span>

                </div>


                <div
                  className={`participation-student-list ${
                    isWideClass
                      ? 'grid grid-cols-1 sm:grid-cols-2 gap-x-3'
                      : 'space-y-1'
                  }`}
                >

                  {blankStudents.map(
                    student => (

                      <div
                        key={
                          `${classItem.className}-${student.no}-blank`
                        }
                        className="participation-student-row flex items-center gap-2 py-1.5 border-b border-amber-50 last:border-0"
                      >

                        <span className="student-no w-12 shrink-0 text-[10px] font-black text-slate-500">
                          {student.no}
                        </span>


                        <span className="student-name min-w-0 flex-1 text-[10px] font-bold text-slate-800 leading-tight">
                          {student.name}
                        </span>


                        <span className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 text-[8px] font-black">
                          BOŞ
                        </span>

                      </div>

                    )
                  )}

                </div>

              </div>

            )}

          </div>

        </div>

      );

    }
  )}

</div>


{/* TAMAMLANAN SINIFLARI TEK SATIRDA GÖSTER */}
{completedClassNames.length > 0 && (

  <div className="participation-complete-strip mt-4 px-4 py-3 rounded-xl border border-emerald-200 bg-emerald-50 flex flex-col sm:flex-row sm:items-center gap-2">

    <span className="text-[10px] font-black uppercase tracking-wide text-emerald-700 shrink-0">
      ✓ Tamamlanan Sınıflar
    </span>

    <span className="text-[11px] font-bold text-emerald-800">
      {completedClassNames.join(', ')}
    </span>

  </div>

)}


      <div className="mt-5 px-4 py-3 rounded-xl border border-slate-200 bg-slate-50 text-[10px] leading-relaxed font-semibold text-slate-500">

        Bu liste yalnızca form katılım durumunu gösterir.
        Öğrencilerin Öğrenci Bilgi Formu cevapları, sağlık bilgileri,
        aile bilgileri veya diğer özel içerikleri bu listede yer almaz.

      </div>

    </div>

  </div>

)}


        {/* 3'LÜ RİSK SÜTUNLARI */}
<div
  className={`grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4 shrink-0 avoid-break ${
    activeReportTab === 'summary'
      ? ''
      : 'hidden'
  }`}
>
          
          {/* 1. AİLE DİNAMİKLERİ */}
          <div className="bg-white p-6 print:p-5 rounded-3xl border border-slate-200 shadow-sm print:border-slate-300">
             <h3 className="font-black text-blue-800 uppercase tracking-widest text-sm mb-4 border-b-2 border-blue-100 pb-2">Aile Dinamikleri</h3>
             <ul className="space-y-4">
                <li className="flex justify-between items-center bg-blue-50 p-3 rounded-xl">
                   <span className="text-xs font-bold text-slate-700">Kayıp (Vefat) Toplam</span>
                   <span className="text-lg font-black text-blue-700">{data.toplamVefat} <span className="text-[10px] font-normal text-slate-500">(%{getPercent(data.toplamVefat)})</span></span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-medium text-slate-600">- Anne Vefat</span>
                   <span className="text-sm font-bold text-slate-800">{data.anneVefat}</span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-medium text-slate-600">- Baba Vefat</span>
                   <span className="text-sm font-bold text-slate-800">{data.babaVefat}</span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-medium text-slate-600">- İkisi de Vefat</span>
                   <span className="text-sm font-bold text-slate-800">{data.ikisiVefat}</span>
                </li>
                <li className="flex justify-between items-center pt-2 px-1">
                   <span className="text-xs font-bold text-slate-700">Parçalanmış Aile (Ayrı)</span>
                   <span className="text-base font-black text-orange-600">{data.parcalanmisAile}</span>
                </li>
                <li className="flex justify-between items-center px-1">
                   <span className="text-xs font-bold text-slate-700">Ebeveyn Dışı Bakım</span>
                   <span className="text-base font-black text-slate-800">{data.ebeveynDisiBakim}</span>
                </li>
             </ul>
          </div>

          {/* 2. EKONOMİK GÖSTERGELER */}
          <div className="bg-white p-6 print:p-5 rounded-3xl border border-slate-200 shadow-sm print:border-slate-300">
             <h3 className="font-black text-emerald-800 uppercase tracking-widest text-sm mb-4 border-b-2 border-emerald-100 pb-2">Ekonomik Profil</h3>
             <ul className="space-y-4">
                <li className="flex justify-between items-center bg-emerald-50 p-3 rounded-xl">
                   <span className="text-xs font-bold text-slate-700">Düşük Gelir / Yok</span>
                   <span className="text-lg font-black text-emerald-700">{data.dusukGelir} <span className="text-[10px] font-normal text-slate-500">(%{getPercent(data.dusukGelir)})</span></span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-bold text-slate-700">Kirada Oturanlar</span>
                   <span className="text-base font-black text-slate-800">{data.kiradaOturan}</span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-bold text-slate-700">Çalışan Öğrenci</span>
                   <span className="text-base font-black text-amber-600">{data.calisanOgrenci}</span>
                </li>
                <li className="flex justify-between items-center px-1">
                   <span className="text-xs font-bold text-slate-700">Çok Kardeşli (5+)</span>
                   <span className="text-base font-black text-slate-800">{data.cokKardesli}</span>
                </li>
             </ul>
          </div>

          {/* 3. SAĞLIK VE ÖZEL DURUM */}
          <div className="bg-white p-6 print:p-5 rounded-3xl border border-slate-200 shadow-sm print:border-slate-300">
             <h3 className="font-black text-rose-800 uppercase tracking-widest text-sm mb-4 border-b-2 border-rose-100 pb-2">Sağlık & Fiziksel</h3>
             <ul className="space-y-4">
                <li className="flex justify-between items-center bg-rose-50 p-3 rounded-xl">
                   <span className="text-xs font-bold text-slate-700">Kronik Hastalık</span>
                   <span className="text-lg font-black text-rose-700">{data.kronikHasta} <span className="text-[10px] font-normal text-slate-500">(%{getPercent(data.kronikHasta)})</span></span>
                </li>
                <li className="flex justify-between items-center border-b border-slate-100 pb-2 px-1">
                   <span className="text-xs font-bold text-slate-700">Sürekli İlaç Kullanımı</span>
                   <span className="text-base font-black text-slate-800">{data.surekliIlac}</span>
                </li>
             </ul>
          </div>
        </div>

        {/* 🚀 YENİ: KATEGORİZE EDİLMİŞ ÖĞRENCİ LİSTELERİ */}
        <div
  className={`mt-10 pt-8 border-t-2 border-slate-200 print:mt-6 print:pt-6 page-break-before-auto ${
    activeReportTab === 'summary'
      ? ''
      : 'hidden'
  }`}
>
           <h3 className="text-2xl print:text-xl font-black text-slate-800 mb-6 flex items-center">
             <AlertTriangle className="h-7 w-7 mr-3 text-slate-700"/>
             Kategorize Edilmiş Öğrenci Listeleri
           </h3>

           <div className="space-y-6 print:space-y-5">
              
              {/* Ortak Öğrenci Kartı Çizici Fonksiyon (Kod tekrarını ve görüntü kirliliğini önler) */}
              {(() => {
                 const StudentGrid = ({ list }) => (
                    <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 print:grid-cols-3 gap-3">
                       {list.map((item, i) => (
                          <div key={i} className="bg-slate-50 border border-slate-100 rounded-lg px-3 py-2 text-xs font-semibold text-slate-700 flex items-center print:bg-white print:border-slate-200 shadow-sm">
                             <span className="w-5 h-5 rounded-md bg-slate-200 text-slate-600 flex items-center justify-center text-[10px] mr-2.5 shrink-0 print:bg-slate-100 font-black">{i + 1}</span>
                             <span className="leading-tight">{item}</span>
                          </div>
                       ))}
                    </div>
                 );

                 return (
                    <>
                      {/* 1. Kayıp / Vefat */}
                      {data.listeler.vefat.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Kayıp / Vefat Durumu Olan Öğrenciler ({data.listeler.vefat.length})
                            </div>
                            <StudentGrid list={data.listeler.vefat} />
                         </div>
                      )}

                      {/* 2. Parçalanmış Aile */}
                      {data.listeler.parcalanmis.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Anne-Baba Ayrı Olan Öğrenciler ({data.listeler.parcalanmis.length})
                            </div>
                            <StudentGrid list={data.listeler.parcalanmis} />
                         </div>
                      )}

                      {/* 3. Ebeveyn Dışı Bakım */}
                      {data.listeler.ebeveynDisi.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Ebeveyn Dışı Bakım (Akraba / Diğer) ({data.listeler.ebeveynDisi.length})
                            </div>
                            <StudentGrid list={data.listeler.ebeveynDisi} />
                         </div>
                      )}

                      {/* 4. Ekonomik Risk */}
                      {data.listeler.ekonomikRisk.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Ekonomik Desteğe İhtiyaç Duyan Öğrenciler ({data.listeler.ekonomikRisk.length})
                            </div>
                            <StudentGrid list={data.listeler.ekonomikRisk} />
                         </div>
                      )}

                      {/* 5. Çalışan Öğrenci */}
                      {data.listeler.calisan.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Okul Dışında Çalışan Öğrenciler ({data.listeler.calisan.length})
                            </div>
                            <StudentGrid list={data.listeler.calisan} />
                         </div>
                      )}

                      {/* 6. Kronik Hastalık */}
                      {data.listeler.saglik.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Sürekli/Kronik Hastalığı Olan Öğrenciler ({data.listeler.saglik.length})
                            </div>
                            <StudentGrid list={data.listeler.saglik} />
                         </div>
                      )}

                      {/* 7. Sürekli İlaç Kullanımı */}
                      {data.listeler.surekliIlac.length > 0 && (
                         <div className="bg-white border border-slate-200 rounded-xl overflow-hidden print:border-slate-300 avoid-break shadow-sm">
                            <div className="bg-slate-100 px-4 py-3 border-b border-slate-200 font-bold text-slate-800 text-sm uppercase tracking-wider flex items-center print:bg-slate-200 print:text-black">
                               Sürekli İlaç Kullanan Öğrenciler ({data.listeler.surekliIlac.length})
                            </div>
                            <StudentGrid list={data.listeler.surekliIlac} />
                         </div>
                      )}
                    </>
                 );
              })()}

              {/* Eğer hiçbir risk listelenmemişse */}
              {Object.values(data.listeler).every(liste => liste.length === 0) && (
                 <div className="text-center p-8 text-slate-500 font-bold border border-dashed border-slate-300 rounded-2xl bg-slate-50 print:bg-white print:border-slate-200">
                    Bu grupta listelenecek ilgili kayıt bulunmamaktadır.
                 </div>
              )}
           </div>
        </div>

      </div>
    </div>
  );
};